export default {"src":"/_next/static/media/gg-play-btn.acf7fa0c.svg","height":238,"width":800,"blurWidth":0,"blurHeight":0};